import React, { Component } from 'react'
import { bool, func, string } from 'prop-types'
import Modal from 'react-modal'
import { translate } from 'react-i18next'
import RadioGroup from '../ui/inputs/RadioGroup'
import Radio from '../ui/inputs/Radio'
import { stores } from '../../stores'
import { getErrorTranslation } from '../../utilities/errors'

class CancellationModalComponent extends Component {
  constructor () {
    super()
    this.state = { error: '', reason: '' }
  }

  async handleSubmit () {
    const { t, id } = this.props
    const { reason } = this.state
    if (!reason) {
      return this.setState({ error: t('common:fields:mandatory_value') })
    }
    try {
      await stores.inquiries.cancel({ proposal: id, reason })
      this.close()
      if (this.props.onCancel) {
        this.props.onCancel()
      }
    } catch (e) {
      this.setState({ error: getErrorTranslation(t, e) })
    }
  }

  close () {
    if (this.props.handleClose) {
      this.props.handleClose()
    }
  }

  render () {
    const { t } = this.props
    return (
      <Modal
        isOpen={this.props.isOpen}
        onRequestClose={() => this.close()}
        contentLabel='Minimal Modal Example'
        className='modal modal--auto'
        overlayClassName='signup_overlay'>
        <span onClick={() => this.close()} style={{cursor: 'pointer'}} className='ReactModal__close'><img src='/app/images/close.png' alt='' /></span>
        <p className='paragraph--centered'>
          {t('common:visits:cancelation_message_1')} <br />
          {t('common:visits:cancelation_message_2')}
        </p>
        <RadioGroup className='modal__cancel__choice' name='reason' onChange={(reason) => this.setState({ reason })} selectedValue={this.state.reason} >
          <div>
            <Radio value='WEATHER'>{ t('common:ponctual:weather_cancellation') }</Radio>
            <Radio value='PERSONAL'>{ t('common:ponctual:personal_cancellation') }</Radio>
            <Radio value='REPORT'>{ t('common:ponctual:report_cancellation') }</Radio>
          </div>
        </RadioGroup>
        <div className='modal__cancel__actions'>
          {
            this.state.error && this.state.error !== ''
            ? <p className='paragraph--centered form__errormessage' style={{ marginBottom: 20 }}>{this.state.error}</p>
            : ''
          }
          <button onClick={() => this.close()} className='btn--lined btn--small jardinier__choice__btn'>{t('common:buttons:cancel')}</button>
          <button onClick={() => this.handleSubmit()} className='btn--default btn--small jardinier__choice__btn'>{t('common:buttons:confirm')}</button>
        </div>
      </Modal>
    )
  }
}

CancellationModalComponent.propTypes = {
  id: string,
  isOpen: bool,
  handleClose: func,
  onCancel: func,
  t: func
}

CancellationModalComponent.defaultProps = {
  isOpen: false
}

export const CancellationModal = translate()(CancellationModalComponent)



// WEBPACK FOOTER //
// ./src/components/modals/CancellationModal.js